export const STRIPE_PLANS: { [K in PaymentPlanKeys]: PaymentPlanValues } = <const>{
  buysidePro: 'BUYSIDE_PRO',
  retailTier1: 'RETAIL_TIER_1', // Elite
  retailTier2: 'RETAIL_TIER_2', // Premium
  retailTier3: 'RETAIL_TIER_3', // Lite
  event: 'EVENT'
};

type PlanTypes = 'retail' | 'tokenBased' | 'buyside';

export type PaymentPlanValues =
  | 'BUYSIDE_PRO'
  | 'RETAIL_TIER_1'
  | 'RETAIL_TIER_2'
  | 'RETAIL_TIER_3'
  | 'EVENT';
export type PaymentPlanKeys =
  | 'buysidePro'
  | 'retailTier1'
  | 'retailTier2'
  | 'retailTier3'
  | 'event';
export type PriceType = 'per year' | 'per bundle' | 'per month';

export const availablePlans: { [Plan in PlanTypes]: PaymentPlanValues[] } = {
  retail: [STRIPE_PLANS.retailTier3, STRIPE_PLANS.retailTier2, STRIPE_PLANS.retailTier1],
  tokenBased: [STRIPE_PLANS.retailTier3, STRIPE_PLANS.retailTier2],
  buyside: [STRIPE_PLANS.buysidePro]
};

export interface PlanInfo {
  name: PaymentPlanKeys;
  price: number;
  sellingPoints: Array<{ [key: string]: string[] }>;
  title: string;
  type: PriceType;
}
